export const URLS = {
    HOME: { url: "/", forGuests: true, forMembers: true, title: "" },
    RULES: { url: "/rules", forGuests: true, forMembers: true, title: "תקנון" },
    LOGIN: { url: "/login", forGuests: true, forMembers: false, title: "התחברות" },
    REGISTER: { url: "/register", forGuests: true, forMembers: false, title: "רישום" },
    ACCOUNT: { url: "/account", forGuests: false, forMembers: true, title: "החשבון שלי" },
    MY_TEAM: { url: "/myteam", forGuests: false, forMembers: true, title: "הנבחרת שלי" },
    PLAYOFF: { url: "/playoff", forGuests: false, forMembers: true, title: "משחקי פלייאוף" },
    USER: { url: "/user", forGuests: true, forMembers: true, title: "דף משתמש" },
    PLAYER: { url: "/player", forGuests: true, forMembers: true, title: "דף שחקן" },
    UPLOAD: { url: "/upload", forGuests: false, forMembers: true, title: "העלאה" },
    // REVIEW: { url: "/review", forGuests: true, forMembers: true, title: "משוב" },
    SAFSAL: { url: "https://safsal.co.il" },
    SAFSALEAGE: { url: "safsal.netlify.app" },
};

export const APP_NAME = "ספסליג";
